import React, { useState } from 'react';

const FAQSection = () => {
  // State to track active FAQ
  const [activeIndex, setActiveIndex] = useState(null);

  // Toggle the visibility of the FAQ answer
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // FAQ items data
  const faqs = [
    {
      question: "How to book a Cab for a city tour with SHREE Tours & Travels?",
      answer: "Booking a Cab for a city tour is simple! You can do it through our website. Select the type of vehicle you prefer and we will assign the best driver for your journey."
    },
    {
      question: "Can I Book a Cab for airport transport with SHREE Tours & Travels?",
      answer: "Yes! You can Book a Cab for airport transport via our website. Just enter your pick-up location, choose the airport destination and confirm your booking."
    },
    {
      question: "Are the drivers at SHREE Tours & Travels professionally trained?",
      answer: "Yes, all our drivers are professionally trained and have a thorough knowledge of the routes, ensuring you a safe and pleasant journey."
    },
    {
      question: "Can I book a Cab for outstation travel with SHREE Tours & Travels?",
      answer: "Absolutely! You can book a Cab for outstation travel via our  website. Choose your pick-up and drop-off locations and we will provide you with the best vehicle and driver for a comfortable journey."
    },
    {
      question: "What payment methods are accepted by SHREE Tours & Travels?",
      answer: "We accept a variety of payment methods, including Google Pay, PhonePe and cash payments. You can choose the most convenient payment option for your trip."
    }
  ];
  
  

  return (
    <section className="faqs-section-three">
      <div className="auto-container">
        <div className="row">
          <div className="image-column col-lg-7">
            <div className="inner-column wow fadeInRight">
              <figure className="image reveall">
                <img src="images/resource/faq1-1.jpg" alt="FAQ Image" />
              </figure>
            </div>
          </div>

          {/* FAQ Column */}
          <div className="faq-column col-lg-5">
            <div className="inner-column">
              <div className="sec-title light">
                {/* <span className="sub-title">Have you any question?</span> */}
                <h2 className="letters-slide-up text-split">Frequently Asked Questions</h2>
              </div>
              <ul className="accordion-box style-two wow fadeInLeft">
                {faqs.map((faq, index) => (
                  <li key={index} className={`accordion block ${activeIndex === index ? 'active-block' : ''}`}>
                    <div
                      className="acc-btn"
                      onClick={() => handleToggle(index)}
                    >
                      {index + 1}. {faq.question}
                      <div className="icon fa fa-chevron-right"></div>
                    </div>
                    <div className={`acc-content ${activeIndex === index ? 'current' : ''}`}>
                      <div className="content">
                        <div className="text">{faq.answer}</div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
